export const resetButtonStyle = {
  backgroundColor: '#F7F7F7',
  border: 'none',
  color: '#74a50a',
  display: 'flex',
  alignItems: 'center',
  height: '13px',
  float: 'right',
};
